import "../App.css";
import "../styles/login.css";
import { withRouter } from "react-router-dom";
import iconPrueba from "../imagenes/170.png";
import { useState } from "react";
import * as msal from "@azure/msal-browser";
import Parametros from "../components/Parametros";
import CurrentUser from "./CurrentUser";

function UserTab(props) {
  // const { history } = props
  // eslint-disable-next-line
  const [usuario, setUsuario] = useState(CurrentUser.user);

  const getInitials = (name) => {
    if (!name) return "?";
    const parts = name.trim().split(/\s+/);
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };
  //

  // Provider de esta sesión = el del JWT en localStorage (no el primario del .env).
  const sessionProvider = CurrentUser.providerOfStoredToken();
  const usedAzure = sessionProvider === "azure";

  const msalInstance =
    Parametros.enabledProviders.includes("azure")
      ? new msal.PublicClientApplication(Parametros.msalConfig)
      : null;

  const displayName =
    (usuario.account && usuario.account.name) ||
    (usuario.hmcyaUsers &&
      [usuario.hmcyaUsers.first_name, usuario.hmcyaUsers.lastname]
        .filter(Boolean)
        .join(" ")) ||
    usuario.email;
  const displayEmail =
    (usuario.account && usuario.account.username) || usuario.email;

  let logout = async () => {
    localStorage.removeItem("usuario");
    localStorage.removeItem("jwt");
    if (usedAzure && msalInstance) {
      await msalInstance.logoutRedirect();
    } else {
      window.location.href = "/";
    }
  };

  return (
    <>
      <div style={{ height: "55px" }}></div>
      <header className="headerNew">
        <h3 className="headerModule">{props.nombre}</h3>

        <div style={{ position: "absolute", right: "20%", top: "20px" }}>
          <div
            onClick={() => logout()}
            className="userAvatar"
            title="Cerrar sesion"
          >
            {getInitials(displayName)}
          </div>
          &nbsp;
          <i style={{ fontSize: "20px", position: "relative" }}>
            {displayName}
          </i>
          <i
            style={{
              fontSize: "10px",
              position: "absolute",
              left: "40px",
              top: "25px",
            }}
          >
            {displayEmail}
          </i>
        </div>
      </header>
    </>
  );
}

export default withRouter(UserTab);
